import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const HoverCopyWrapper = styled(Box)`
  width: 100%;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: space-between;

  .copy-btn {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  &:hover .copy-btn {
    opacity: 1;
  }
`;
